import styled from '@emotion/styled';

export const InputContainer = styled.div`
	display: flex;
	color: ${({ disabled }) => (disabled ? 'var(--content-4)' : 'var(--secondaryColor)')};
	background: ${({ disabled }) => (disabled ? 'var(--input-disabled-bg-color)' : 'var(--input-bg-color)')};

	input[type='color'] {
		cursor: pointer;
		transition: all 0.2s ease;
		border-radius: var(--small-border-radius);
		padding: 0;
		height: 3rem;
		width: 5rem;
		border: 1px solid var(--secondaryColor);

		&::-webkit-color-swatch-wrapper {
			padding: 0;
		}

		&::-webkit-color-swatch {
			border-radius: 0.3rem;
			border: none;
			outline: none;
		}
	}
`;
